import { db } from "../../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

export async function loadAllDriversMap() {
  const snap = await getDocs(collection(db, "drivers"));
  const map = {};

  snap.forEach((d) => {
    const data = d.data();
    map[d.id] = {
      company: data.company || "",
      fullName: data.fullName || "",
    };
  });

  return map;
}
